/*
 * Giovese Family Wines — Squarespace home migration
 * Behaviors: scroll-state header, mobile drawer, nav-folder accordions.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // --- Scroll-state header (transparent → dark on scroll) ---
    var header = document.querySelector('.giovese-header');
    if (header && (!header.classList.contains('giovese-header--solid') || header.classList.contains('giovese-header--faq'))) {
      var scrollThreshold = 40;
      var ticking = false;
      function updateHeader() {
        if (window.scrollY > scrollThreshold) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });
      updateHeader();
    }

    // --- Compensate body padding-top so content doesn't hide behind sticky wrapper ---
    var sticky = document.querySelector('.giovese-sticky-top');
    var announcementClose = document.querySelector('[data-giovese-announcement-close]');
    var announcement = document.querySelector('.giovese-announcement');
    var isFaqHeader = !!document.querySelector('.giovese-header--faq');
    function syncAnnouncementOffset() {
      var offset = announcement && !announcement.hidden ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--giovese-announcement-offset', offset + 'px');
    }
    function syncBodyPadding() {
      if (sticky && !document.querySelector('.giovese-hero')) {
        var offset = isFaqHeader && announcement && !announcement.hidden ? announcement.offsetHeight : sticky.offsetHeight;
        document.body.style.paddingTop = offset + 'px';
      }
    }
    syncAnnouncementOffset();
    window.addEventListener('resize', syncAnnouncementOffset);
    if (announcementClose) {
      announcementClose.addEventListener('click', function () {
        var currentAnnouncement = announcementClose.closest('.giovese-announcement');
        if (!currentAnnouncement) return;
        currentAnnouncement.hidden = true;
        syncAnnouncementOffset();
        syncBodyPadding();
      });
    }

    if (sticky && !document.querySelector('.giovese-hero')) {
      // Only on non-home pages where the hero doesn't naturally overlap behind a transparent header
      syncBodyPadding();
      window.addEventListener('resize', syncBodyPadding);
    }

    // --- Mobile drawer ---
    var toggle = document.querySelector('[data-giovese-drawer-open]');
    var close = document.querySelector('[data-giovese-drawer-close]');
    var drawer = document.querySelector('[data-giovese-drawer]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (toggle) toggle.addEventListener('click', openDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // --- FAQ accordion smooth open/close ---
    document.querySelectorAll('.giovese-faq__item').forEach(function (details) {
      var summary = details.querySelector('summary');
      var answer = details.querySelector('.giovese-faq__answer');
      if (!summary || !answer) return;
      var fallbackTimer;
      var activeAnimation;

      function clearInlineState() {
        window.clearTimeout(fallbackTimer);
        if (activeAnimation) {
          activeAnimation.cancel();
          activeAnimation = null;
        }
        answer.style.height = '';
        answer.style.opacity = '';
        answer.style.overflow = '';
        answer.style.transition = '';
        answer.style.paddingTop = '';
        answer.style.paddingBottom = '';
        details.dataset.animating = 'false';
      }

      function finishAnimation(callback, duration) {
        window.clearTimeout(fallbackTimer);
        if (!activeAnimation) return;
        activeAnimation.onfinish = function () {
          activeAnimation = null;
          callback();
        };
        fallbackTimer = window.setTimeout(function () {
          if (activeAnimation) {
            activeAnimation.cancel();
            activeAnimation = null;
          }
          callback();
        }, duration + 120);
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;

        var isOpening = !details.open;
        details.dataset.animating = 'true';

        if (isOpening) {
          details.open = true;
          var openStyle = window.getComputedStyle(answer);
          var openPaddingTop = openStyle.paddingTop;
          var openPaddingBottom = openStyle.paddingBottom;
          var openHeight = answer.scrollHeight;

          answer.style.overflow = 'hidden';
          activeAnimation = answer.animate(
            [
              { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 },
              {
                height: openHeight + 'px',
                paddingTop: openPaddingTop,
                paddingBottom: openPaddingBottom,
                opacity: 1,
              },
            ],
            { duration: 340, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
          );

          finishAnimation(function () {
            clearInlineState();
          }, 340);
        } else {
          var closeStyle = window.getComputedStyle(answer);
          var closePaddingTop = closeStyle.paddingTop;
          var closePaddingBottom = closeStyle.paddingBottom;
          var closeHeight = answer.offsetHeight || answer.scrollHeight;

          answer.style.overflow = 'hidden';
          activeAnimation = answer.animate(
            [
              {
                height: closeHeight + 'px',
                paddingTop: closePaddingTop,
                paddingBottom: closePaddingBottom,
                opacity: 1,
              },
              { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 },
            ],
            { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }
          );

          finishAnimation(function () {
            details.open = false;
            clearInlineState();
          }, 300);
        }
      });
    });

    // --- Mobile drawer folder accordions ---
    document.querySelectorAll('[data-giovese-drawer-folder]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var content = btn.nextElementSibling;
        if (!content) return;
        var open = content.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // --- Desktop nav folder click toggle (also opens on hover via CSS) ---
    document.querySelectorAll('[data-giovese-nav-folder]').forEach(function (folder) {
      var btn = folder.querySelector('.giovese-header__nav-folder-title');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = folder.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('[data-giovese-nav-folder]').forEach(function (f) {
          f.setAttribute('aria-expanded', 'false');
        });
        folder.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-giovese-nav-folder]')) {
        document.querySelectorAll('[data-giovese-nav-folder]').forEach(function (f) {
          f.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // --- Press/image carousel arrows ---
    document.querySelectorAll('[data-giovese-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-giovese-carousel-track]');
      var prev = carousel.querySelector('[data-giovese-carousel-prev]');
      var next = carousel.querySelector('[data-giovese-carousel-next]');
      if (!track) return;

      function itemWidth() {
        var item = track.querySelector('.giovese-carousel__item');
        return item ? item.getBoundingClientRect().width : Math.max(track.clientWidth * 0.18, 280);
      }

      function move(direction) {
        var distance = itemWidth();
        var moving = track.dataset.gioveseMoving === 'true';
        if (moving || track.children.length < 2) return;
        track.dataset.gioveseMoving = 'true';

        track.style.transition = 'none';
        track.style.transform = 'translate3d(0, 0, 0)';
        track.scrollLeft = 0;

        if (direction < 0) {
          var last = track.lastElementChild;
          if (last) track.insertBefore(last, track.firstElementChild);
          track.style.transform = 'translate3d(' + (-distance) + 'px, 0, 0)';
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            track.style.transition = 'transform 420ms ease';
            track.style.transform = 'translate3d(' + (direction > 0 ? -distance : 0) + 'px, 0, 0)';
          });
        });

        window.setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform = 'translate3d(0, 0, 0)';
          if (direction > 0) {
            var first = track.firstElementChild;
            if (first) track.appendChild(first);
          }
          track.dataset.gioveseMoving = 'false';
        }, 460);
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    });

    // --- Product card quantity controls ---
    document.querySelectorAll('.giovese-wine-card__qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;

      qty.querySelectorAll('[data-giovese-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-giovese-qty'), 10) || 0;
          var current = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, current + delta);
        });
      });
    });
  });
})();
